import { Outlet } from "react-router";

import { partnerShellConfig } from "@/apps/partner/utils/partnerShellConfig";
import { PortalPageLayout } from "@/components/Layout/BaseLayouts/PortalPageLayout";
import { PortalShellProvider } from "@/components/Layout/PortalShellConfig";

const PartnerDashboard = () => (
  <PortalShellProvider value={partnerShellConfig}>
    <PortalPageLayout>
      <div className="col-span-full">
        <Outlet />
      </div>
    </PortalPageLayout>
  </PortalShellProvider>
);

export default PartnerDashboard;
